import React from 'react';
import { SectionNotification } from 'wix-ui-tpa/cssVars';
import { TPAComponentsProvider } from 'wix-ui-tpa';
import { Error as ErrorIcon } from '@wix/wix-ui-icons-common/on-stage';
import { classes } from './ErrorSection.st.css';
import { TEXT_DIRECTION } from '../../../constants';
import { useEnvironment } from '@wix/yoshi-flow-editor';

interface ErrorSectionProps {
  error?: string;
}

export const ErrorSection = ({ error }: ErrorSectionProps) => {
  const { isRTL } = useEnvironment();

  if (!error) {
    return null;
  }

  return (
    <div
      data-hook="error-message"
      dir={isRTL ? TEXT_DIRECTION.RTL : TEXT_DIRECTION.LTR}
    >
      <TPAComponentsProvider value={{ rtl: isRTL }}>
        <SectionNotification type="error" className={classes.errorNotification}>
          <SectionNotification.Icon icon={<ErrorIcon />} />
          <SectionNotification.Text>{error}</SectionNotification.Text>
        </SectionNotification>
      </TPAComponentsProvider>
    </div>
  );
};
